import { connect } from 'react-redux';
import { getFilterIdentifierCount } from '../../store/openOrder';

import FilterIdentifierPanel from './FilterIdentifierPanel';

const mapStateToProps = state => ({
  filterCount: getFilterIdentifierCount(state),
  filters: state.pto.openPtos.filters,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FilterIdentifierPanel);
